<template>
  <div>
    <div class="case-pice">
      <span class="case-pice-first">支付流水</span>
      <span class="case-pice-and">/</span>
      <span class="case-pice-second">首页</span>
    </div>
    <div style="display: flex">
      <div class="commom-input-label-short">学员姓名：</div>
      <div class="common-full-width-style">
        <el-input
          v-model="searchData.name"
          clearable
          class="common-full-width"
          size="small"
          placeholder="请输入学员姓名"
        ></el-input>
      </div>
      <div class="commom-input-label-short">学员编号：</div>
      <div class="common-full-width-style">
        <el-input
          v-model="searchData.certificationNo"
          clearable
          class="common-full-width"
          size="small"
          placeholder="请输入学员编号"
        ></el-input>
      </div>
      <div class="commom-input-label-short">支付日期：</div>
      <div class="common-full-width-style">
        <el-date-picker
          v-model="payTime"
          clearable
          size="small"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="common-full-width"
        ></el-date-picker>
      </div>
      <div class="commom-input-label-short">手机号码：</div>
      <div class="common-full-width-style">
        <el-input
          v-model="searchData.phone"
          clearable
          class="common-full-width"
          size="small"
          placeholder="请输入手机号码"
        ></el-input>
      </div>
      <div
        style="text-align: right; width: 100px; height: 60px; line-height: 60px"
      >
        <el-button size="small" type="primary" @click="exportTable()" plain
          >报表导出</el-button
        >
      </div>
    </div>
    <div style="display: flex">
      <div class="commom-input-label-short">培训类别：</div>
      <div class="common-full-width-style">
        <el-select
          size="small"
          class="common-full-width"
          clearable
          v-model="searchData.trainingClasses"
          placeholder="请选择培训类别"
        >
          <el-option
            v-for="item in tarinTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="commom-input-label-short">专业类别：</div>
      <div class="common-full-width-style">
        <el-select
          size="small"
          class="common-full-width"
          v-model="searchData.professionalClasses"
          clearable
          placeholder="请选择专业类别"
        >
          <el-option
            v-for="(item, index) in majorCategoryList"
            :key="index"
            :label="item.codeCname"
            :value="item.codeCode"
          >
          </el-option>
        </el-select>
      </div>
      <div class="commom-input-label-short">培训人员：</div>
      <div class="common-full-width-style">
        <el-select
          size="small"
          class="common-full-width"
          v-model="searchData.trainers"
          clearable
          placeholder="请选择培训人员"
        >
          <el-option
            v-for="item in trainersList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="commom-input-label-short">会员单位：</div>
      <div class="common-full-width-style">
        <el-select
          size="small"
          class="common-full-width"
          v-model="searchData.companyId"
          clearable
          placeholder="请选择会员单位"
        >
          <el-option
            v-for="item in companyListData"
            :key="item.companyId"
            :label="item.companyName"
            :value="item.companyId"
          >
          </el-option>
        </el-select>
      </div>
      <div
        style="text-align: right; width: 100px; height: 60px; line-height: 60px"
      >
        <el-button
          size="small"
          style="width: 88px"
          type="primary"
          @click="search()"
          plain
          icon="el-icon-search"
          >查询</el-button
        >
      </div>
    </div>
    <div style="display: flex">
      <div class="commom-input-label-short">开票状态：</div>
      <div class="common-full-content">
        <el-select
          size="small"
          class="common-full-width"
          v-model="searchData.type"
          clearable
          placeholder="请选择开票状态"
        >
          <el-option
            v-for="item in invoiceList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="commom-input-label-short">备注:</div>
      <div class="common-full-content">
        <div class="common-full-width-style">
          <el-input
            v-model="searchData.note"
            clearable
            class="common-full-width"
            placeholder="请输入备注"
          ></el-input>
        </div>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      stripe
      height=" calc(100vh - 270px)"
    >
      <el-table-column label="序号" width="60">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        show-overflow-tooltip
        label="学员姓名"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="certificationNo"
        show-overflow-tooltip
        label="学员编号"
        min-width="150"
      >
      </el-table-column>
      <el-table-column show-overflow-tooltip label="性别" width="60">
        <template slot-scope="scope">
          <span v-if="scope.row.sex == 1">女</span>
          <span v-else>男</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="phone"
        show-overflow-tooltip
        label="手机号码"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        prop="trainingClasses"
        show-overflow-tooltip
        label="培训类别"
        min-width="100"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.trainingClasses == 1">初次培训</span>
          <span v-if="scope.row.trainingClasses == 2">继续教育</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="professionalClasses"
        show-overflow-tooltip
        label="专业类别"
        min-width="150"
      ></el-table-column>
      <el-table-column show-overflow-tooltip label="培训人员" min-width="120">
        <template slot-scope="scope" min-width="100">
          <span v-if="scope.row.trainers == 1">负责人</span>
          <span v-if="scope.row.trainers == 2">安全管理人员</span>
          <span v-if="scope.row.trainers == 3">动态监控</span>
          <span v-if="scope.row.trainers == 4">其他</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="companyName"
        show-overflow-tooltip
        label="会员单位"
        min-width="250"
      >
      </el-table-column>
      <el-table-column show-overflow-tooltip label="支付状态" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.payStatus == 0">待支付</span>
          <span v-if="scope.row.payStatus == 1">已支付</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="开票状态" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1" style="color: green">已开票</span>
          <span v-else>未开票</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="feeNum"
        show-overflow-tooltip
        label="支付金额"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        prop="note"
        show-overflow-tooltip
        label="备注"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        prop="payTime"
        show-overflow-tooltip
        label="支付时间"
        min-width="200"
      >
      </el-table-column>
      <el-table-column
        prop="payType"
        show-overflow-tooltip
        label="支付方式"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="orderId"
        show-overflow-tooltip
        label="流水号码"
        min-width="200"
      >
      </el-table-column>
      <el-table-column
        prop="openId"
        show-overflow-tooltip
        label="OpenID"
        min-width="300"
      >
      </el-table-column>
      <el-table-column
        prop="mchId"
        show-overflow-tooltip
        label="商户ID"
        min-width="120"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <!-- 填写备注 -->
          <el-button
            size="mini"
            type="primary"
            @click="writeBill(scope.row)"
            plain
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNumber"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="驳回原因"
      :visible.sync="dialogBillVisible"
      v-if="dialogBillVisible"
      width="40%"
    >
      <div style="display: flex">
        <!--<div class='bill-left-block'>
					驳回原因：
				</div>-->
        <div style="flex: 1">
          <el-input
            v-model="returnReason"
            type="textarea"
            row="3"
            clearable
            class="common-full-width"
            size="small"
            placeholder="请输入驳回原因"
          ></el-input>
        </div>
      </div>
      <div style="text-align: center; height: 50px; line-height: 50px">
        <el-button size="small" type="primary" @click="defineSave()" plain
          >确定</el-button
        >
        <el-button
          size="small"
          type="info"
          @click="dialogBillVisible = false"
          plain
          >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- 填写备注 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="15%"
      :before-close="handleClose"
      class="upload-dialog"
    >
      <div style="display: flex">
        <div class="commom-input-label-short">备注：</div>
        <div class="common-full-width-style">
          <el-input
            v-model="note"
            clearable
            class="common-full-width"
            size="small"
            placeholder="请输入备注"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitNote">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  applicationFormList,
  examOrBack,
  majorTypeList,
  getPayList,
  companyList,
  noteUpdate,
} from "../../api/main";
export default {
  data() {
    return {
      payTime: "",
      searchData: {
        name: "",
        certificationNo: "",
        phone: "",
        trainingClasses: "",
        professionalClasses: "",
        trainers: "",
        companyId: "",
        payTimeStart: "",
        payTimeEnd: "",
        // type:'',
      },
      dialogVisible: false,
      options: [
        {
          label: "未更正",
          value: "未更正",
        },
        {
          label: "已更正",
          value: "已更正",
        },
      ],
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalNumber: 0,
      safetyList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "0",
        },
      ],
      tarinTypeList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "初次培训",
          value: "1",
        },
        {
          label: "继续教育",
          value: "2",
        },
      ],
      majorCategoryList: [],
      trainersList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "负责人",
          value: "1",
        },
        {
          label: "安全管理人员",
          value: "0",
        },
        {
          label: "动态监控",
          value: "3",
        },
        {
          label: "其他",
          value: "4",
        },
      ],
      stateList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未审核",
          value: "1",
        },
        {
          label: "已取消",
          value: "0",
        },
        {
          label: "审核通过",
          value: "2",
        },
        {
          label: "审核驳回",
          value: "3",
        },
      ],
      // 开票状态
      invoiceList: [
        {
          label: "全部",
          value: "0",
        },
        {
          label: "已开票",
          value: "1",
        },
        {
          label: "未开票",
          value: "2",
        },
      ],
      dialogBillVisible: false,
      nowId: "",
      returnReason: "",
      companyListData: [],
      note: "", //备注
      orderId: "", // 订单id
    };
  },
  mounted() {
    this.getSignUpList();
    this.getMajorDataList();
    this.getCompanyList();
  },
  methods: {
    getCompanyList() {
      companyList({
        companyName: "",
        creditCode: "",
        current: 1,
        pageSize: 100,
      }).then((res) => {
        console.log(res);
        this.companyListData = res.data.records;
        this.companyListData.unshift({
          companyName: "全部",
          companyId: "",
        });
      });
    },
    defineSave() {
      this.$confirm("确定驳回所选项吗？", "审核驳回", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          examOrBack({
            applicationFormId: this.nowId,
            applicationStatus: 3,
          }).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "驳回成功",
              });
              this.search();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消驳回",
          });
        });
    },
    exportTable() {
      this.tableData.forEach((item, index) => {
        if (item.sex == 0) {
          item.sexName = "男";
        }
        if (item.sex == 1) {
          item.sexName = "女";
        }
        if (item.trainers == "1") {
          item.trainersName = "负责人";
        }
        if (item.education == 2) {
          item.trainersName = "安全管理人员";
        }
        if (item.trainingClasses == "1") {
          item.trainingClassesName = "初次培训";
        }
        if (item.trainingClasses == 2) {
          item.trainingClassesName = "继续教育";
        }
        if (item.payStatus == 1) {
          item.payStatusName = "已支付";
        }
        if (item.payStatus == 0) {
          item.payStatusName = "待支付";
        }
      });
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/common/js/Export2Excel");
        const tHeader = [
          "学员名称",
          "学员编号",
          "性别",
          "手机号码",
          "培训类别",
          "专业类别",
          "培训人员",
          "会员单位",
          "支付状态",
          "支付金额",
          "支付时间",
          "支付方式",
          "流水号码",
          "OpenId",
          "商户ID",
        ];
        // 上面设置Excel的表格第一行的标题
        const filterVal = [
          "name",
          "certificationNo",
          "sexName",
          "phone",
          "trainingClassesName",
          "professionalClasses",
          "trainersName",
          "companyName",
          "payStatusName",
          "feeNum",
          "payTime",
          "payType",
          "orderId",
          "openId",
          "mchId",
        ];
        // 上面的 goodsName、goodsId、是exportData里对象的属性
        const list = this.tableData; //把data里的exportData存到list
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "支付流水信息");
      });
    },
    // 写备注
    writeBill(vl) {
      this.orderId = vl.orderId;
      this.dialogVisible = true;
	  this.note = vl.note;
    },
    // 关闭写备注
    handleClose() {
      this.dialogVisible = false;
	  this.note = "";
    },
    // 提交备注
    submitNote() {
      const data = { orderId: this.orderId, note: this.note };
      noteUpdate(data).then((res) => {
        if (res.code == 1) {
          this.getSignUpList();
          this.handleClose();
        } else {
          this.$message.error(res.msg);
        }
      });
	  this.note = "";
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    getMajorDataList() {
      majorTypeList({
        current: 1,
        pageSize: 30,
        professionalName: "",
      }).then((res) => {
        this.majorCategoryList = res.data.records;
        this.majorCategoryList.unshift({
          codeCname: "全部",
          codeCode: "",
        });
      });
    },
    getSignUpList() {
      var dateStr = "";
      if (this.$util.getNowDate(this.payTime[0])) {
        var dateStr =
          this.$util.getNowDate(this.payTime[0]) +
          "," +
          this.$util.getNowDate(this.payTime[1]);
        this.searchData.payTimeStart = this.$util.getNowDate(this.payTime[0]);
        this.searchData.payTimeEnd = this.$util.getNowDate(this.payTime[1]);
      }
      this.searchData.pageSize = this.pageSize;
      this.searchData.current = this.currentPage;
      getPayList(this.searchData).then((res) => {
        console.log(res);

        this.tableData = res.data.records;
        this.totalNumber = parseInt(res.data.total);
      });
    },
    search() {
      this.currentPage = 1;
      this.getSignUpList();
    },
    handleSizeChange(data) {
      this.pageSize = data;
      this.getSignUpList();
    },
    handleCurrentChange(data) {
      this.currentPage = data;
      this.getSignUpList();
    },
    checkMember(row) {
      this.$confirm("确定更正所选项吗？", "企业更正", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "更正成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消更正",
          });
        });
    },
    lookMemberInfo(row) {
      this.$store.state.signUpRecordId = row.id;
      this.$router.push("/SignUpDetail");
    },
    examineSign(text, row) {
      if (text == "pass") {
        this.$confirm("确定通过所选项吗？", "审核通过", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            examOrBack({
              applicationFormId: row.applicationFormId,
              applicationStatus: 2,
            }).then((res) => {
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: "审核成功",
                });
                this.search();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消审核",
            });
          });
      } else if (text == "turn") {
        this.dialogBillVisible = true;
        this.nowId = row.applicationFormId;
      } else {
        this.$store.state.signUpRecordId = row.applicationFormId;
        this.$router.push("/SignUpDetail");
      }
    },
  },
};
</script>

<style lang="less">
.common-full-content {
  width: 17.5%;
  line-height: 60px;
  padding: 0 10px;
}
.el-dialog__wrapper {
  .el-dialog {
    border-radius: 10px; /* 设置圆角大小 */
  }
}

.upload-dialog {
  .el-dialog__header {
    border-radius: 10px;
    .center-title .el-dialog__title {
      text-align: center;
      font-size: 18px;
      font-weight: bold;
    }
    background: white;
    .el-dialog__title {
      color: black;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: black;
    }
  }
}
</style>